import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { CommonService } from '../../../_services/common.service';
import { ScriptLoaderService } from '../../../_services/script-loader.service';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from '../../../theme/home/translateConfig.service';
import { Helpers } from '../../../helpers';
import { PrintFormatsComponent } from '../../../print-formats/print-formats.component';
declare var $: any;

const LNG_KEY = "SELECTED_LANGUAGE";
@Component({
  selector: 'app-new-print-formats',
  templateUrl: './new-print-formats.component.html',
  styleUrls: ['./new-print-formats.component.scss']
})
export class NewPrintFormatsComponent implements OnInit {

  hostURL = environment.apiUrl;
  hostUrl = environment.apiUrl;
  static NewPrintFormatsComponent: NewPrintFormatsComponent;

  selectedLang: string;
  imgPath: any;
  CompanyId: any;
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  HeadBranchGST: any;
  HeadBranchCIN: any;
  SelectedCompanyLogo: any;
  TenantId: any;
  TermsAndCondition: any;
  TermsandConditions: any;
  UseManualLRNumberFlag: any = false;
  SelectedCompanyHeadAdd: any;
  SelectedCompanyWebsite: any;

  ConsignmentsData: any = [];
  LorryReceiptData: any = [];
  dataLoaded = false;
  LorryReceiptPrint2 = false;
  ConsignmentNote_2 = [1, 2, 3];
  ConsignmentNote_3 = [1, 2, 3, 4];
  ShipmentModeName: any;
  SelectedCompantEmail: any;
  SelectedCompanyPAN: any;
  containerNo: any;
  sealNo: any;

  @ViewChild(PrintFormatsComponent) PrintFormatsChild: PrintFormatsComponent;

  constructor(
    private _script: ScriptLoaderService,
    private _appService: appService,
    private commonService: CommonService,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    private cookieservice: CookieService,
    private translate: TranslateService,
    private service: TranslateConfigService,
    private cdr: ChangeDetectorRef
  ) {
    NewPrintFormatsComponent.NewPrintFormatsComponent = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.SelectedComapnyName = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedComapnyName;
    this.SelectedCompanyAdd = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyAdd;
    this.SelectedCompanyCIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyCIN;
    this.SelectedCompantGSTIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompantGSTIN;
    this.HeadBranchGST = JSON.parse(localStorage.getItem("ChnageCompnayId")).HeadBranchGST;
    this.HeadBranchCIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).HeadBranchCIN;
    this.SelectedCompanyLogo = JSON.parse(localStorage.getItem("ChnageCompnayId")).CompanyLogoPath;
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.TermsAndCondition = JSON.parse(localStorage.getItem("ChnageCompnayId")).TermsAndConditions;
    this.UseManualLRNumberFlag = JSON.parse(localStorage.getItem("UseManualLRNumberFlag"));
    this.SelectedCompanyHeadAdd = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyHeadAdd;
    this.SelectedCompanyWebsite = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).Website;
    this.SelectedCompantEmail = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedComapnyEmail;
    this.SelectedCompanyPAN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyPAN;
    this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
  }

  PrintDropdownSelecteData(item, row) {

    this.GetTermsAndConditions();
    if (item.Code == 0 || item.Code == '0') {
      this.GetLorryReceiptPrint(row.ConsignmentNoteId);
    }
    if (item.Code == 1 || item.Code == '1') {
      NewPrintFormatsComponent.NewPrintFormatsComponent.ShipmentModeName = row.ShipmentModeName;
      // this.GetLorryReceiptPrint1(row.ConsignmentNoteId);
      this.GetLorryReceiptPrint2(row.ConsignmentNoteId, row.BookingId);
    }
    if (item.Code == 2 || item.Code == '2') {
      this.GetLorryReceiptPrint3(row.ConsignmentNoteId, row.BookingId);
    }
    if (item.Code == 3 || item.Code == '3') {
      NewPrintFormatsComponent.NewPrintFormatsComponent.PrintFormatsChild.InvoiceType = 'PrintLorryReceipt4';
      NewPrintFormatsComponent.NewPrintFormatsComponent.PrintFormatsChild.From = 'Origin';
      NewPrintFormatsComponent.NewPrintFormatsComponent.PrintFormatsChild.ConsignmentNoteId = row.ConsignmentNoteId;
      NewPrintFormatsComponent.NewPrintFormatsComponent.PrintFormatsChild.CompId = NewPrintFormatsComponent.NewPrintFormatsComponent.CompanyId;
      $("#PrintInvoice").val("");
      NewPrintFormatsComponent.NewPrintFormatsComponent.PrintFormatsChild.PrintInvoice();
    }
  }

  GetTermsAndConditions() {
    this._appService.GetById("Company", "GetTermsAndConditionForPrint", this.CompanyId).subscribe(
      (response) => {
        // const strippedText = response.replace(/<\/?[^>]+(>|$)/g, "");
        this.TermsandConditions = response;
        // console.log("GetTermsAndConditions:", response);
      },
      (error) => {
        console.log("GetTermsAndConditions", error);
      }
    );
  }

  // GetLorryReceiptPrint(ConsignmentNoteId) {
  //   Helpers.setLoading(true);
  //   this._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe(
  //     (response) => {
  //       this.LorryReceiptData = [];
  //       this.LorryReceiptData = response as any;
  //       console.log("ConsignmentsData:", this.LorryReceiptData);
  //       let i = 0;
  //       setTimeout(() => {
  //         this.LorryReceiptData.forEach(
  //           (element) => {

  //             var TotalQty = 0;
  //             var TotalWeight = 0;
  //             var TotalValue = 0;
  //             element.ProductDetail.forEach((element) => {
  //               TotalQty = TotalQty + element.Quantity;
  //               TotalWeight = TotalWeight + element.GrossWeight;
  //               TotalValue = TotalValue + element.Value;
  //             });

  //             element.TotalQty = TotalQty;
  //             element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
  //             element.TotalValue = TotalValue;
  //             i++;
  //           }
  //         );

  //         setTimeout(() => {
  //           var divElements = document.getElementById("Test");
  //           // this.LorryReceiptData = [];
  //           // this.LorryReceiptData.push({ id: 0 });
  //           // this.LorryReceiptData.push({ id: 1 });
  //           // this.LorryReceiptData.push({ id: 2 });
  //           console.log("divElements:", divElements);
  //           var $iframe: any = $("<iframe id='frame'>").appendTo("body");
  //           var printDiv =
  //             "<html><head><title> Lorry Receipt </title></head><body>" +
  //             divElements.innerHTML +
  //             "</body></html>";
  //           $iframe.contents().find("body").html(printDiv);
  //           var win = $iframe[0].contentWindow || $iframe[0];
  //           $(win.document).ready(function () {
  //             setTimeout(() => {
  //               win.window.print();
  //               setTimeout(() => {
  //                 $iframe.remove();
  //               }, 500);
  //             }, 100);
  //           });
  //           Helpers.setLoading(false);
  //           $iframe.contents().find("body").html(printDiv);
  //         }, 1000);
  //       }, 200);

  //     },
  //     (err) => {
  //       Helpers.setLoading(false);
  //       this.toastr.error("An error occured  !", "Error");
  //     });
  // }

  // GetLorryReceiptPrint(ConsignmentNoteId) {
  //   Helpers.setLoading(true);
  //   this._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe((response) => {
  //     NewPrintFormatsComponent.NewPrintFormatsComponent.LorryReceiptData = response;

  //     let i = 0;
  //     setTimeout(() => {
  //       NewPrintFormatsComponent.NewPrintFormatsComponent.LorryReceiptData.forEach((element) => {
  //         var TotalQty = 0;
  //         var TotalWeight = 0;
  //         var TotalValue = 0;
  //         element.ProductDetail.forEach((element) => {
  //           TotalQty = TotalQty + element.Quantity;
  //           TotalWeight = TotalWeight + element.GrossWeight;
  //           TotalValue = TotalValue + element.Value;
  //         });

  //         element.TotalQty = TotalQty;
  //         element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
  //         element.TotalValue = TotalValue;
  //         i++;
  //       });

  //       // Set the flag to true when the data is loaded
  //       this.dataLoaded = true;

  //       // Only proceed with printing after data is loaded
  //       if (this.dataLoaded) {
  //         setTimeout(() => {
  //           
  //           console.log("ConsignmentsData:", NewPrintFormatsComponent.NewPrintFormatsComponent.LorryReceiptData);
  //           var divElements = document.getElementById("Test_123");
  //           console.log("divElements:", divElements);
  //           var $iframe: any = $("<iframe id='frame'>").appendTo("body");
  //           var printDiv =
  //             "<html><head><title> Lorry Receipt </title></head><body>" +
  //             divElements.innerHTML +
  //             "</body></html>";
  //           $iframe.contents().find("body").html(printDiv);
  //           var win = $iframe[0].contentWindow || $iframe[0];
  //           $(win.document).ready(function () {
  //             setTimeout(() => {
  //               win.window.print();
  //               setTimeout(() => {
  //                 $iframe.remove();
  //               }, 500);
  //             });
  //           });
  //           Helpers.setLoading(false);
  //           $iframe.contents().find("body").html(printDiv);
  //         }, 1000);
  //       }
  //     }, 200);
  //   }, (err) => {
  //     Helpers.setLoading(false);
  //     this.toastr.error("An error occurred!", "Error");
  //   });
  // }


  GetLorryReceiptPrint(ConsignmentNoteId) {
    Helpers.setLoading(true);
    this._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe(
      (response) => {
        this.ConsignmentsData = [];
        this.ConsignmentsData = response;
        this.dataLoaded = true;
        this.cdr.detectChanges(); // Force UI update

        let i = 0;
        this.ConsignmentsData.forEach((element) => {


          if (
            element.Risk == "Owner" ||
            element.Risk == "owner" ||
            element.Risk == "OWNER"
          ) {
            $("#chkOwn_" + i).attr("checked", true);
          } else {
            $("#chkTransporter_" + i).attr("checked", true);
          }

          if (
            element.Freight == "To Pay" ||
            element.Freight == "to pay" ||
            element.Freight == "To pay" ||
            element.Freight == "TO PAY" ||
            element.Freight == "ToPay"
          ) {
            $("#chkToPay_" + i).attr("checked", true);
          } else {
            $("#chkToBill_" + i).attr("checked", true);
          }

          if (
            element.GST == "Consignor" ||
            element.GST == "consignor" ||
            element.GST == "CONSIGNOR"
          ) {
            $("#chkConsignor_" + i).attr("checked", true);
          } else {
            $("#chkGSTTransporter_" + i).attr("checked", true);
          }

          if (element.Insured) {
            $("#chkInsureYes_" + i).attr("checked", true);
          } else {
            $("#chkInsureNo_" + i).attr("checked", true);
          }

          let TotalQty = 0;
          let TotalWeight = 0;
          let TotalValue = 0;
          element.ProductDetail.forEach((product) => {
            TotalQty += product.Quantity;
            TotalWeight += product.GrossWeight;
            TotalValue += product.Value;
          });

          element.TotalQty = TotalQty;
          element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
          element.TotalValue = TotalValue;
          i++;
        });

        setTimeout(() => {
          console.log("ConsignmentsData:", this.ConsignmentsData);
          let divElements = document.getElementById("ModalConsignmentNoteX");
          console.log("divElements:", divElements);
          let $iframe: any = $("<iframe id='frame'>").appendTo("body");
          let printDiv = `<html><head><title> Lorry Receipt </title></head><body>${divElements.innerHTML}</body></html>`;
          $iframe.contents().find("body").html(printDiv);
          let win = $iframe[0].contentWindow || $iframe[0];
          $(win.document).ready(function () {
            setTimeout(() => {
              win.window.print();
              setTimeout(() => {
                $iframe.remove();
              }, 500);
            });
          });

          Helpers.setLoading(false);
        }, 1000);
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("An error occurred!", "Error");
      }
    );
  }

  GetLorryReceiptPrint1(ConsignmentNoteId) {
    
    this._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe(
      (response) => {
        this.ConsignmentsData = [];
        this.ConsignmentsData = response;

        let i = 0;
        setTimeout(() => {
          this.ConsignmentsData.forEach((element) => {

            if (
              element.Risk == "Owner" ||
              element.Risk == "owner" ||
              element.Risk == "OWNER"
            ) {
              $("#chkOwn_" + i).attr("checked", true);
            } else {
              $("#chkTransporter_" + i).attr("checked", true);
            }

            if (
              element.Freight == "To Pay" ||
              element.Freight == "to pay" ||
              element.Freight == "To pay" ||
              element.Freight == "TO PAY" ||
              element.Freight == "ToPay"
            ) {
              $("#chkToPay_" + i).attr("checked", true);
            } else {
              $("#chkToBill_" + i).attr("checked", true);
            }

            if (
              element.GST == "Consignor" ||
              element.GST == "consignor" ||
              element.GST == "CONSIGNOR"
            ) {
              $("#chkConsignor_" + i).attr("checked", true);
            } else {
              $("#chkGSTTransporter_" + i).attr("checked", true);
            }

            if (element.Insured) {
              $("#chkInsureYes_" + i).attr("checked", true);
            } else {
              $("#chkInsureNo_" + i).attr("checked", true);
            }

            let TotalQty = 0;
            let TotalWeight = 0;
            let TotalValue = 0;
            element.ProductDetail.forEach((product) => {
              TotalQty += product.Quantity;
              TotalWeight += product.GrossWeight;
              TotalValue += product.Value;
            });

            element.TotalQty = TotalQty;
            element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
            element.TotalValue = TotalValue;
            i++;
          });
        }, 200);
      },
      (err) => {
        console.error(err);
      });
  }

  GetLorryReceiptPrint2(ConsignmentNoteId, BookingId) {
    Helpers.setLoading(true);
    this._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe(
      (response) => {
        NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData = [];
        NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData = response;
        if (NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData.length > 0)
          NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData[0].ShipmentModeName = NewPrintFormatsComponent.NewPrintFormatsComponent.ShipmentModeName;
        let i = 0;
        NewPrintFormatsComponent.NewPrintFormatsComponent._appService
          .GetByTwoId("Booking", "GetDataForLRPrint", BookingId, NewPrintFormatsComponent.NewPrintFormatsComponent.CompanyId)
          .subscribe(
            (response) => {
              Helpers.setLoading(false);
              if (response.length > 0) {
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData[0].DriverName =
                  response[0].DriverName;
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData[0].VehicleType =
                  response[0].VehicleType;
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData[0].transporterAddress =
                  response[0].transporterAddress;
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData[0].LicenseNo =
                  response[0].LicenseNo;
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData[0].TransportName =
                  response[0].TransportName;
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData[0].eWayBillNo =
                  response[0].eWayBillNo;
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData[0].eWayBillExpiryDate =
                  response[0].eWayBillExpiryDate;
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData[0].containerNo =
                  response[0].containerNo;
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData[0].sealNo =
                  response[0].sealNo;
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData[0].DINo =
                  response[0].DINo;
              }

              setTimeout(() => {
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData.forEach(
                  (element) => {
                    if (
                      element.Risk == "Owner" ||
                      element.Risk == "owner" ||
                      element.Risk == "OWNER"
                    ) {
                      $("#chkOwn_" + i).attr("checked", true);
                    } else {
                      $("#chkTransporter_" + i).attr(
                        "checked",
                        true
                      );
                    }

                    if (
                      element.Freight == "To Pay" ||
                      element.Freight == "to pay" ||
                      element.Freight == "To pay" ||
                      element.Freight == "TO PAY" ||
                      element.Freight == "ToPay"
                    ) {
                      $("#chkToPay_" + i).attr("checked", true);
                    } else {
                      $("#chkToBill_" + i).attr("checked", true);
                    }

                    if (
                      element.GST == "Consignor" ||
                      element.GST == "consignor" ||
                      element.GST == "CONSIGNOR"
                    ) {
                      $("#chkConsignor_" + i).attr("checked", true);
                    } else {
                      $("#chkGSTTransporter_" + i).attr(
                        "checked",
                        true
                      );
                    }

                    if (element.Insured) {
                      $("#chkInsureYes_" + i).attr("checked", true);
                    } else {
                      $("#chkInsureNo_" + i).attr("checked", true);
                    }

                    var TotalQty = 0;
                    var TotalWeight = 0;
                    var TotalValue = 0;
                    element.ProductDetail.forEach((element) => {
                      TotalQty = TotalQty + element.Quantity;
                      TotalWeight =
                        TotalWeight + element.GrossWeight;
                      TotalValue = TotalValue + element.Value;
                    });

                    element.TotalQty = TotalQty;
                    element.TotalWeight = parseFloat(
                      TotalWeight.toFixed(2)
                    );
                    element.TotalValue = TotalValue;
                    i++;
                  }
                );
              }, 200);

              this.LorryReceiptPrint2 = true;

              setTimeout(() => {

                console.log("ConsignmentsData:", NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData);
                let divElements = document.getElementById("ModalLorryReceipt2");
                console.log("divElements:", divElements);
                let $iframe: any = $("<iframe id='frame'>").appendTo("body");
                let printDiv = `<html><head><title> Lorry Receipt 2</title></head><body>${divElements.innerHTML}</body></html>`;
                $iframe.contents().find("body").html(printDiv);
                let win = $iframe[0].contentWindow || $iframe[0];
                $(win.document).ready(function () {
                  setTimeout(() => {
                    win.window.print();
                    setTimeout(() => {
                      $iframe.remove();
                    }, 500);
                  });
                });
                Helpers.setLoading(false);
              }, 1000);
            },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("An error occurred!", "Error");
            }
          );
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("An error occured  !", "Error");
      }
    );
  }

  GetLorryReceiptPrint3(ConsignmentNoteId, BookingId) {
    Helpers.setLoading(true);
    this._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe(
      (response) => {
        NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData = [];
        NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData = response;
        let i = 0;
        NewPrintFormatsComponent.NewPrintFormatsComponent._appService
          .GetByTwoId("Booking", "GetDataForLRPrint", BookingId, NewPrintFormatsComponent.NewPrintFormatsComponent.CompanyId)
          .subscribe(
            (response) => {
              Helpers.setLoading(false);
              if (response.length > 0) {
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData.forEach(
                  (elementCN1) => {
                    elementCN1.DriverName = response[0].DriverName;
                    elementCN1.VehicleType = response[0].VehicleType;
                    elementCN1.transporterAddress =
                      response[0].transporterAddress;
                    elementCN1.LicenseNo = response[0].LicenseNo;
                    elementCN1.TransportName =
                      response[0].TransportName;
                    elementCN1.eWayBillNo = response[0].eWayBillNo;
                    elementCN1.eWayBillExpiryDate =
                      response[0].eWayBillExpiryDate;
                    elementCN1.containerNo = response[0].containerNo;
                  }
                );
              }

              if (
                NewPrintFormatsComponent
                  .NewPrintFormatsComponent.ConsignmentsData[0]
                  .ReferenceNo != null
              ) {
                let printSealNo =
                  NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData[0].ReferenceNo.split(
                    "/"
                  );
                NewPrintFormatsComponent.NewPrintFormatsComponent.containerNo =
                  printSealNo[0];
                this.containerNo = printSealNo[0];
                if (printSealNo[1]) {
                  NewPrintFormatsComponent.NewPrintFormatsComponent.sealNo =
                    printSealNo[1].split(":")[1];
                  this.sealNo = printSealNo[1].split(":")[1];
                }
              }

              setTimeout(() => {
                NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData.forEach(
                  (element) => {
                    if (
                      element.Risk == "Owner" ||
                      element.Risk == "owner" ||
                      element.Risk == "OWNER"
                    ) {
                      $("#chkOwn_" + i).attr("checked", true);
                    } else {
                      $("#chkTransporter_" + i).attr(
                        "checked",
                        true
                      );
                    }

                    if (
                      element.Freight == "To Pay" ||
                      element.Freight == "to pay" ||
                      element.Freight == "To pay" ||
                      element.Freight == "TO PAY" ||
                      element.Freight == "ToPay"
                    ) {
                      $("#chkToPay_" + i).attr("checked", true);
                    } else {
                      $("#chkToBill_" + i).attr("checked", true);
                    }

                    if (
                      element.GST == "Consignor" ||
                      element.GST == "consignor" ||
                      element.GST == "CONSIGNOR"
                    ) {
                      $("#chkConsignor_" + i).attr("checked", true);
                    } else {
                      $("#chkGSTTransporter_" + i).attr(
                        "checked",
                        true
                      );
                    }

                    if (element.Insured) {
                      $("#chkInsureYes_" + i).attr("checked", true);
                    } else {
                      $("#chkInsureNo_" + i).attr("checked", true);
                    }

                    var TotalQty = 0;
                    var TotalWeight = 0;
                    var TotalValue = 0;
                    element.ProductDetail.forEach((element) => {
                      TotalQty = TotalQty + element.Quantity;
                      TotalWeight =
                        TotalWeight + element.GrossWeight;
                      TotalValue = TotalValue + element.Value;
                    });

                    element.TotalQty = TotalQty;
                    element.TotalWeight = parseFloat(
                      TotalWeight.toFixed(2)
                    );
                    element.TotalValue = TotalValue;
                    i++;
                  }
                );
              }, 200);

              // this.LorryReceiptPrint2 = true;

              setTimeout(() => {

                console.log("ConsignmentsData:", NewPrintFormatsComponent.NewPrintFormatsComponent.ConsignmentsData);
                let divElements = document.getElementById("ModalLorryReceipt3");
                console.log("divElements:", divElements);
                let $iframe: any = $("<iframe id='frame'>").appendTo("body");
                let printDiv = `<html><head><title> Lorry Receipt 2</title></head><body>${divElements.innerHTML}</body></html>`;
                $iframe.contents().find("body").html(printDiv);
                let win = $iframe[0].contentWindow || $iframe[0];
                $(win.document).ready(function () {
                  setTimeout(() => {
                    win.window.print();
                    setTimeout(() => {
                      $iframe.remove();
                    }, 500);
                  });
                });
                Helpers.setLoading(false);
              }, 1000);
            },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("An error occurred!", "Error");
            }
          );
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("An error occured  !", "Error");
      }
    );
  }


}
